import axios, { AxiosInstance } from 'axios';
import getConfig from 'next/config';
import { getCookie } from './cookie';
import { coubicLocale } from './i18n';
import { getRequestHost } from './request-url';

const { publicRuntimeConfig } = getConfig();

// XXX: これ普通に非同期処理で別の文脈のuaType, localeが入りうる, 壊れてる
// FIXME: AsyncLocalStorageを使う必要がある...
let uaType = '';
let coubicLocaleString: coubicLocale | '' = '';

export function setUaType(uatype: string) {
  uaType = uatype || '';
}

export function setCoubicLocaleRequestHeader(locale: coubicLocale) {
  coubicLocaleString = locale;
}

// For SSR
export const newSecuredAxios = (params: {
  session?: string;
  token?: string;
  requestId?: string;
  merchantPublicId?: string;
}): AxiosInstance => {
  const headers: Record<string, string> = {
    'X-Request-Id': params.requestId ?? '',
    'X-Coubic-Locale': coubicLocaleString,
    'X-Merchant-Public-Id': params.merchantPublicId ?? '',
    'Api-Env': publicRuntimeConfig.coubicEnv,
    Uatype: uaType,
  };
  // if session is blank, fetch from cookie
  // need to fetch when intercepting for client side login
  const token = params.token || getCookie('token') || '';
  if (token) {
    headers['Access-Token'] = token;
  }

  const session = params.session || getCookie('cb') || '';
  if (session) {
    headers.Cookie = `cb=${encodeURIComponent(session)};`;
  }

  if (typeof window === 'undefined') {
    // FIXME: 個別の buildApiV2Url 呼び出しが、この関数の返値の AxiosInstance の利用側となっているので
    //        このヘッダの設定に対応するリクエスト先指定が分散してしまってる (buildApiV2Url のデフォルトの振る舞いで吸収しているが...)
    //        src/openapi/generated/apiClient のような分離ができたほうがいい...?
    headers['X-Coubic-Request-Host'] = getRequestHost();
  }

  return axios.create({
    headers,
  });
};

// For CSR
const securedAxios = ((): AxiosInstance => {
  return newSecuredAxios({});
})();

// securedAxiosがanonymous functionでラップされているため、誤検知されていると思われる
// もしくは、指摘の通りこの書き方だとFast Refresh時にlocal stateが保持されないのかもしれない
// ただ、いずれにしても対応は大変そうなので`eslint-disable`で対応します

// eslint-disable-next-line import/no-anonymous-default-export
export default securedAxios;
